// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"imageShow_wrapper__2-orl","bg":"imageShow_bg__2UJDq","img":"imageShow_img__dObYq","wrapper_icon":"imageShow_wrapper_icon__i1hkG"};